import { assertNever, type KeyDateDto } from '@signalvote/shared';

export type KeyDateStatus = 'election' | 'upcoming' | 'overdue' | 'filed';

export interface KeyDateItem {
  key: string;
  label: string;
  status: KeyDateStatus;
}

function toItem(keyDate: KeyDateDto, campaignToday: string): KeyDateItem {
  switch (keyDate.kind) {
    case 'Election':
      return { key: `election-${keyDate.stage}`, label: keyDate.label, status: 'election' };
    case 'FilingDeadline':
      return {
        key: `deadline-${keyDate.deadlineId}`,
        label: keyDate.label,
        status: keyDate.filed ? 'filed' : keyDate.date < campaignToday ? 'overdue' : 'upcoming',
      };
    default:
      return assertNever(keyDate);
  }
}

/** `campaignToday` is the campaign-timezone `yyyy-MM-dd` from `getCampaignTodayString()`. */
export function groupKeyDatesByDate(keyDates: readonly KeyDateDto[], campaignToday: string): Map<string, KeyDateItem[]> {
  const byDate = new Map<string, KeyDateItem[]>();
  for (const keyDate of keyDates) {
    const item = toItem(keyDate, campaignToday);
    const bucket = byDate.get(keyDate.date);
    if (bucket) bucket.push(item);
    else byDate.set(keyDate.date, [item]);
  }
  for (const bucket of byDate.values()) {
    bucket.sort((a, b) => Number(b.status === 'election') - Number(a.status === 'election'));
  }
  return byDate;
}
